import { render, staticRenderFns } from "./pregnancy.vue?vue&type=template&id=d9f5f1ae&"
import script from "./pregnancy.vue?vue&type=script&lang=js&"
export * from "./pregnancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports